// Utility to extract the best error message from backend errors (including nested API errors)
export function extractApiErrorMessage(error) {
  if (!error) return 'Unknown error';
  // If error is an object with .message
  if (typeof error === 'object' && error.message) return error.message;
  // If error is a string, try to extract nested JSON error
  if (typeof error === 'string') {
    // Try to match {"error":"..."}
    const match = error.match(/\{\"error\":\"(.*?)\"\}/);
    if (match && match[1]) return match[1];
    // Otherwise, return the string itself
    return error;
  }
  // Fallback
  return 'Unknown error';
}

// Utility to extract the best error message from an API error object (Axios/fetch)
export function getApiErrorMessage(err) {
  if (!err) return 'Unknown error';
  // Axios: err.response.data.error or err.response.data.message
  if (err.response && err.response.data) {
    if (err.response.data.error) return err.response.data.error;
    if (err.response.data.message) return err.response.data.message;
    if (typeof err.response.data === 'string') return err.response.data;
  }
  // Fetch: err.message
  if (err.message) return err.message;
  // Fallback
  return typeof err === 'string' ? err : 'Unknown error';
}

// For logging errors to console with a consistent format
export function logError(context, error) {
  console.error(`[${context}] Error:`, getApiErrorMessage(error));
  console.error(error); // Log the full error for debugging
}
